/* =============================================
   BONITA BLOMSTER — Product Page JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ---- Image Gallery ----
  const mainImage = document.getElementById('product-main-image');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.alt;
      }
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // ---- Variant Selector ----
  const variantBtns = document.querySelectorAll('.variant-btn');
  const variantInput = document.getElementById('variant-id');
  const priceEl = document.getElementById('product-price');

  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      variantBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (variantInput) variantInput.value = btn.dataset.variantId;
      if (priceEl && btn.dataset.price) {
        const price = parseInt(btn.dataset.price) / 100;
        priceEl.textContent = price.toLocaleString('nb-NO', {
          style: 'currency',
          currency: 'NOK',
          minimumFractionDigits: 2
        });
      }
    });
  });

  // ---- Add-on Drawer ----
  const drawer = document.getElementById('addon-drawer');
  const drawerOverlay = document.getElementById('addon-drawer-overlay');
  const drawerClose = document.getElementById('addon-drawer-close');
  const drawerTitle = document.getElementById('addon-drawer-title');
  const drawerOptions = document.getElementById('addon-drawer-options');
  let activeAddonCard = null;

  function openDrawer(addonLabel, isSelected) {
    if (!drawer) return;

    document.querySelectorAll('.addon-option').forEach(opt => {
      opt.style.display = opt.dataset.parent === addonLabel ? 'flex' : 'none';
    });

    if (drawerTitle) drawerTitle.textContent = addonLabel;

    let removeBtn = document.getElementById('addon-drawer-remove');
    if (!removeBtn) {
      removeBtn = document.createElement('button');
      removeBtn.id = 'addon-drawer-remove';
      removeBtn.className = 'addon-drawer__remove';
      removeBtn.textContent = drawer.dataset.removeLabel || 'Remove this add-on';
      drawerOptions.prepend(removeBtn);
    }
    removeBtn.style.display = isSelected ? 'block' : 'none';

    removeBtn.onclick = () => {
      if (activeAddonCard) {
        activeAddonCard.setAttribute('aria-pressed', 'false');
        const originalLabel = activeAddonCard.dataset.addonLabel.split(':')[0].trim();
        activeAddonCard.dataset.addonLabel = originalLabel;
        const priceSpan = activeAddonCard.querySelector('.addon-card__price');
        if (priceSpan) priceSpan.textContent = '';
        document.querySelectorAll(`.addon-option[data-parent="${originalLabel}"]`).forEach(o => {
          o.classList.remove('is-selected');
        });
      }
      updateAddonInputs();
      updateMessageVisibility();
      closeDrawer();
    };

    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activeAddonCard = null;
  }

  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // Option selection inside drawer
  document.querySelectorAll('.addon-option').forEach(opt => {
    opt.addEventListener('click', () => {
      const parent = opt.dataset.parent;
      const label = opt.dataset.label;
      const price = opt.dataset.price;

      // Mark option as selected
      document.querySelectorAll(`.addon-option[data-parent="${parent}"]`).forEach(o => {
        o.classList.remove('is-selected');
      });
      opt.classList.add('is-selected');

      // Update the parent addon card
      if (activeAddonCard) {
        activeAddonCard.setAttribute('aria-pressed', 'true');
        activeAddonCard.dataset.addonLabel = `${parent}: ${label}`;
        activeAddonCard.dataset.addonPrice = price;
        const priceSpan = activeAddonCard.querySelector('.addon-card__price');
        if (priceSpan) priceSpan.textContent = (drawer.dataset.priceLabel || '+{{ price }} NOK').replace('{{ price }}', price);
      }

      updateAddonInputs();
      updateMessageVisibility();
      closeDrawer();
    });
  });

  // ---- Add-on Cards ----
  const addonCards = document.querySelectorAll('.addon-card');
  const addonInputsContainer = document.getElementById('addon-inputs');
  const messageBoxCard = document.getElementById('product-message-card');
  const messageBoxRibbon = document.getElementById('product-message-ribbon');

  function updateAddonInputs() {
    if (!addonInputsContainer) return;
    addonInputsContainer.innerHTML = '';
    addonCards.forEach(card => {
      if (card.getAttribute('aria-pressed') === 'true') {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${card.dataset.addonLabel}]`;
        input.value = 'Yes';
        addonInputsContainer.appendChild(input);
      }
    });
  }

  function updateMessageVisibility() {
    addonCards.forEach(card => {
      const isPressed = card.getAttribute('aria-pressed') === 'true';
      const hasMessage = card.dataset.isCard === 'true';
      const isRibbon = card.dataset.addonLabel.toLowerCase().includes('ribbon');

      if (hasMessage && !isRibbon) {
        if (messageBoxCard) {
          messageBoxCard.style.display = isPressed ? 'block' : 'none';
          if (!isPressed) { const ta = messageBoxCard.querySelector('textarea'); if (ta) ta.value = ''; }
        }
      }

      if (isRibbon) {
        if (messageBoxRibbon) {
          messageBoxRibbon.style.display = isPressed ? 'block' : 'none';
          if (!isPressed) { const ta = messageBoxRibbon.querySelector('textarea'); if (ta) ta.value = ''; }
        }
      }
    });
  }

  addonCards.forEach(card => {
    card.addEventListener('click', () => {
      const hasOptions = card.dataset.hasOptions === 'true';

      if (hasOptions) {
        const isSelected = card.getAttribute('aria-pressed') === 'true';
        activeAddonCard = card;
        openDrawer(card.dataset.addonLabel.split(':')[0].trim(), isSelected);
      } else {
        const pressed = card.getAttribute('aria-pressed') === 'true';
        card.setAttribute('aria-pressed', String(!pressed));
        updateAddonInputs();
        updateMessageVisibility();
      }
    });
  });

  // Escape key closes drawer
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  // ---- Gift extras: card & ribbon as real, paid line items ----
  const CART_PROP_MESSAGE = 'Message';
  let giftConfig = {};
  try {
    const cfgEl = document.getElementById('gift-extras-config');
    if (cfgEl) giftConfig = JSON.parse(cfgEl.textContent);
  } catch (e) { giftConfig = {}; }
  const giftI18n = giftConfig.i18n || {};

  // Count Unicode code points (not UTF-16 units) so limits are correct for every
  // language and for emoji. True grapheme clusters (flag emoji, combining accents)
  // would need Intl.Segmenter — future refinement.
  const cpLength = (s) => [...(s || '')].length;

  function formatMoney(cents, decimals) {
    return (cents / 100).toLocaleString('nb-NO', {
      style: 'currency', currency: 'NOK',
      minimumFractionDigits: decimals, maximumFractionDigits: decimals
    });
  }

  // Smallest variant whose max >= len; if none fits, the largest (flagged over).
  function pickVariant(variants, len) {
    const sorted = [...variants].sort((a, b) => a.max - b.max);
    for (const v of sorted) { if (len <= v.max) return { variant: v, over: false }; }
    return { variant: sorted[sorted.length - 1], over: true };
  }

  // --- Add-on gift items (card / ribbon shown on a normal product page) ---
  const giftItems = [];
  let selfBlocking = null;

  // Grey out / re-enable Add-to-cart based on every gift message's validity.
  function refreshFormValidity() {
    const atc = document.getElementById('add-to-cart');
    if (!atc) return;
    let blocking = false;
    giftItems.forEach(g => { if (g.isBlocking()) blocking = true; });
    if (selfBlocking && selfBlocking()) blocking = true;
    atc.disabled = blocking;
    atc.classList.toggle('is-disabled', blocking);
  }

  // Message state for a variant list at a given length:
  //   skip  — empty / add-on not selected (optional, not added, not blocking)
  //   short — 1..(min-1) chars (blocking; must reach min or clear)
  //   long  — over the hard maximum (blocking)
  //   valid — within [min, max]
  function messageStatus(variants, len, required) {
    const v = pickVariant(variants, len).variant;
    if (len === 0) return { code: required ? 'short' : 'skip', v, len };
    if (len < v.min) return { code: 'short', v, len };
    if (len > Math.max(...variants.map(x => x.max))) return { code: 'long', v, len };
    return { code: 'valid', v, len };
  }

  function hintFor(code) {
    if (code === 'short') return giftI18n.tooShort || 'Type your message.';
    if (code === 'long') return giftI18n.tooLong || 'Message is too long.';
    return '';
  }

  document.querySelectorAll('.gift-item:not(.gift-item--choice)').forEach(el => {
    const cfg = giftConfig[el.dataset.gift];              // 'card' | 'ribbon'
    if (!cfg || !cfg.variants || !cfg.variants.length) { el.remove(); return; }

    const toggle = el.querySelector('.gift-item__toggle');
    const body = el.querySelector('.gift-item__body');
    const msg = el.querySelector('.gift-item__message');
    const priceEl = el.querySelector('[data-role="price"]');
    const sizeEl = el.querySelector('[data-role="size"]');
    const counterEl = el.querySelector('[data-role="counter"]');
    const errorEl = el.querySelector('[data-role="error"]');
    const hardMax = Math.max(...cfg.variants.map(v => v.max));
    const minPrice = Math.min(...cfg.variants.map(v => v.price));
    const multiSize = cfg.variants.length > 1;
    let added = false;
    let current = pickVariant(cfg.variants, 0).variant;

    if (priceEl) priceEl.textContent = '+' + formatMoney(minPrice, 0);

    // An add-on is optional: empty message = not added (not required).
    const status = () => added ? messageStatus(cfg.variants, cpLength(msg.value), false) : { code: 'skip', v: current, len: 0 };

    function refresh() {
      const st = status();
      current = st.v;
      if (sizeEl) sizeEl.textContent = multiSize ? (current.title + ' · ' + formatMoney(current.price, 0)) : '';
      if (counterEl) counterEl.textContent = st.len + ' / ' + hardMax;
      if (priceEl) priceEl.textContent = '+' + formatMoney(current.price, 0);
      const hint = hintFor(st.code);
      el.classList.toggle('is-invalid', st.code === 'short' || st.code === 'long');
      el.classList.toggle('is-over', st.code === 'long');
      if (errorEl) { errorEl.hidden = !hint; errorEl.textContent = hint; }
      refreshFormValidity();
    }

    toggle.addEventListener('click', () => {
      added = !added;
      toggle.setAttribute('aria-pressed', String(added));
      body.hidden = !added;
      el.classList.toggle('is-added', added);
      if (added) { refresh(); msg.focus(); }
      else {
        msg.value = '';
        el.classList.remove('is-invalid', 'is-over');
        if (errorEl) errorEl.hidden = true;
        refreshFormValidity();
      }
    });
    msg.addEventListener('input', refresh);

    giftItems.push({
      type: el.dataset.gift,
      isIncluded: () => status().code === 'valid',
      isBlocking: () => { const c = status().code; return c === 'short' || c === 'long'; },
      getItem: () => ({ id: current.id, quantity: 1, properties: { [CART_PROP_MESSAGE]: msg.value.trim() } })
    });
  });

  // --- Choice add-ons (chocolates, vases…): pick one option from a collection, no message ---
  const choiceBackdrop = document.getElementById('gift-choice-backdrop');

  if (choiceBackdrop) choiceBackdrop.addEventListener('click', () => {
    document.querySelectorAll('.gift-item--choice.is-drawer-open').forEach(drawerEl => {
      const hasSelection = drawerEl.querySelector('.gift-choice__option[aria-checked="true"]');
      const row = drawerEl.querySelector('[data-role="selected"]');
      const t = drawerEl.querySelector('.gift-item__toggle');
      drawerEl.classList.remove('is-drawer-open');
      if (hasSelection) {
        if (row) row.hidden = false;
        drawerEl.classList.add('is-added');
        if (t) t.setAttribute('aria-pressed', 'true');
      } else {
        drawerEl.classList.remove('is-added');
        if (t) t.setAttribute('aria-pressed', 'false');
      }
    });
    choiceBackdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  });

  document.querySelectorAll('.gift-item--choice').forEach(el => {
    const key = el.dataset.giftChoice;
    const toggle = el.querySelector('.gift-item__toggle');
    const body = el.querySelector('.gift-item__body');
    const closeBtn = body.querySelector('.gift-choice__close');
    const optionsEl = el.querySelector('.gift-choice__options');
    const priceEl = el.querySelector('[data-role="price"]');
    const selectedRow = el.querySelector('[data-role="selected"]');
    const selectedImg = el.querySelector('[data-role="selected-img"]');
    const selectedLabel = el.querySelector('[data-role="selected-label"]');
    const changeBtn = el.querySelector('.gift-choice__selected-change');
    const options = Array.from(el.querySelectorAll('.gift-choice__option'));
    if (!options.length) { el.remove(); return; }

    const prices = options.map(o => parseInt(o.dataset.price, 10) || 0);
    if (priceEl) priceEl.textContent = '+' + formatMoney(Math.min(...prices), 0);

    let added = false;
    let selected = null;

    function showSelectedRow(opt) {
      if (!selectedRow) return;
      const img = opt.querySelector('img');
      if (selectedImg) {
        if (img) { selectedImg.src = img.src; selectedImg.alt = img.alt; selectedImg.hidden = false; }
        else { selectedImg.hidden = true; }
      }
      if (selectedLabel) {
        const labelEl = opt.querySelector('.gift-choice__label');
        const priceOptEl = opt.querySelector('.gift-choice__price');
        selectedLabel.textContent = (labelEl ? labelEl.textContent : '') +
          (priceOptEl ? ' · +' + priceOptEl.textContent.replace(/^\+/, '') : '');
      }
      selectedRow.hidden = false;
    }

    function hideSelectedRow() {
      if (selectedRow) selectedRow.hidden = true;
    }

    function openDrawer() {
      document.querySelectorAll('.gift-item--choice.is-drawer-open').forEach(other => {
        if (other !== el) other.classList.remove('is-drawer-open');
      });
      el.classList.add('is-drawer-open');
      if (choiceBackdrop) choiceBackdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      if (optionsEl) optionsEl.classList.remove('is-collapsed');
    }

    function closeDrawer() {
      el.classList.remove('is-drawer-open');
      if (choiceBackdrop) choiceBackdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    function select(opt) {
      if (!opt || opt.disabled) return;
      selected = opt;
      options.forEach(o => o.setAttribute('aria-checked', String(o === opt)));
      if (priceEl) priceEl.textContent = '+' + formatMoney(parseInt(opt.dataset.price, 10) || 0, 0);
    }

    options.forEach(opt => opt.addEventListener('click', () => {
      if (opt.disabled) return;
      select(opt);
      added = true;
      closeDrawer();
      showSelectedRow(opt);
      el.classList.add('is-added');
      toggle.setAttribute('aria-pressed', 'true');
      refreshFormValidity();
    }));

    if (changeBtn) changeBtn.addEventListener('click', () => {
      hideSelectedRow();
      openDrawer();
    });

    if (closeBtn) closeBtn.addEventListener('click', () => {
      closeDrawer();
      if (selected) {
        showSelectedRow(selected);
        el.classList.add('is-added');
        toggle.setAttribute('aria-pressed', 'true');
      } else {
        el.classList.remove('is-added');
        toggle.setAttribute('aria-pressed', 'false');
      }
    });

    toggle.addEventListener('click', () => {
      if (el.classList.contains('is-drawer-open')) {
        closeDrawer();
        if (selected) {
          showSelectedRow(selected);
          el.classList.add('is-added');
          toggle.setAttribute('aria-pressed', 'true');
        } else {
          el.classList.remove('is-added');
          toggle.setAttribute('aria-pressed', 'false');
        }
      } else if (added) {
        // Click again to deselect / remove the add-on
        added = false;
        selected = null;
        options.forEach(o => o.setAttribute('aria-checked', 'false'));
        hideSelectedRow();
        el.classList.remove('is-added');
        toggle.setAttribute('aria-pressed', 'false');
        refreshFormValidity();
      } else {
        openDrawer();
        toggle.setAttribute('aria-pressed', 'true');
      }
    });

    giftItems.push({
      type: key,
      isIncluded: () => added && !!selected && !selected.disabled,
      isBlocking: () => false,
      getItem: () => ({ id: parseInt(selected.dataset.variantId, 10), quantity: 1, properties: {} })
    });
  });

  // --- Standalone gift product (card / ribbon on its own page): message required ---
  if (giftConfig.self && giftConfig.self.variants && giftConfig.self.variants.length) {
    const wrap = document.querySelector('[data-role="self-message"]');
    const msg = wrap && wrap.querySelector('textarea');
    if (wrap && msg) {
      const variants = giftConfig.self.variants;
      const hardMax = Math.max(...variants.map(v => v.max));
      const multiSize = variants.length > 1;
      const sizeEl = wrap.querySelector('[data-role="self-size"]');
      const counterEl = wrap.querySelector('[data-role="self-counter"]');
      const errorEl = wrap.querySelector('[data-role="self-error"]');

      const refreshSelf = () => {
        const st = messageStatus(variants, cpLength(msg.value), true);   // required
        if (variantInput) variantInput.value = st.v.id;
        if (priceEl) priceEl.textContent = formatMoney(st.v.price, 2);
        if (sizeEl) sizeEl.textContent = multiSize ? st.v.title : '';
        if (counterEl) counterEl.textContent = st.len + ' / ' + hardMax;
        const hint = hintFor(st.code);
        wrap.classList.toggle('is-invalid', st.code !== 'valid');
        if (errorEl) { errorEl.hidden = !hint; errorEl.textContent = hint; }
        refreshFormValidity();
      };
      selfBlocking = () => messageStatus(variants, cpLength(msg.value), true).code !== 'valid';
      msg.addEventListener('input', refreshSelf);
      refreshSelf();
    }
  }

  // ---- Add to Cart ----
  const productForm = document.getElementById('product-form');
  const atcBtn = document.getElementById('add-to-cart');

  // Build the base line item from the form (variant id + any properties[...] fields).
  function buildBaseItem() {
    const fd = new FormData(productForm);
    const item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1, properties: {} };
    for (const [key, value] of fd.entries()) {
      const m = key.match(/^properties\[(.+)\]$/);
      if (m && String(value).trim() !== '') item.properties[m[1]] = value;
    }
    return item;
  }

  // Unique token to link a bouquet with the add-ons added alongside it.
  function giftGroupToken() {
    try { return crypto.randomUUID(); }
    catch (e) { return 'g' + Date.now().toString(36) + Math.floor(Math.random() * 1e9).toString(36); }
  }

  if (productForm && atcBtn) {
    atcBtn.dataset.originalText = atcBtn.textContent.trim();
    refreshFormValidity();   // initial state (e.g. standalone card requires a message)

    const atcModal = document.getElementById('atc-modal');
    const atcModalBackdrop = atcModal && atcModal.querySelector('.atc-modal__backdrop');
    const atcModalContinue = atcModal && atcModal.querySelector('.atc-modal__continue');

    function openAtcModal() {
      atcBtn.disabled = false;
      atcBtn.textContent = atcBtn.dataset.originalText;
      refreshFormValidity();
      if (atcModal) { atcModal.hidden = false; document.body.style.overflow = 'hidden'; }
    }

    function closeAtcModal() {
      if (atcModal) { atcModal.hidden = true; document.body.style.overflow = ''; }
    }

    if (atcModalBackdrop) atcModalBackdrop.addEventListener('click', closeAtcModal);
    if (atcModalContinue) atcModalContinue.addEventListener('click', closeAtcModal);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAtcModal(); });

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      // Guard: block if any gift message is too short / too long (button is already greyed).
      let blocking = false;
      giftItems.forEach(g => { if (g.isBlocking()) blocking = true; });
      if (selfBlocking && selfBlocking()) blocking = true;
      if (blocking) { refreshFormValidity(); return; }

      atcBtn.disabled = true;
      atcBtn.textContent = '...';

      const base = buildBaseItem();
      const includedGifts = giftItems.filter(g => g.isIncluded());

      // Link the bouquet and its add-ons with a shared token (only when add-ons exist).
      let token = null;
      if (includedGifts.length) {
        token = giftGroupToken();
        base.properties['_bonita_group'] = token;
      }
      if (base.properties && !Object.keys(base.properties).length) delete base.properties;

      const items = [base];
      includedGifts.forEach(g => {
        const it = g.getItem();
        it.properties['_bonita_group'] = token;
        it.properties['_bonita_addon'] = g.type;   // 'card' | 'ribbon'
        items.push(it);
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (response.ok) {
          updateCartCount();
          atcBtn.textContent = '✓ ' + (atcBtn.dataset.added || 'Added');
          atcBtn.style.background = 'var(--color-secondary)';
          atcBtn.style.borderColor = 'var(--color-secondary)';
          setTimeout(() => {
            atcBtn.style.background = '';
            atcBtn.style.borderColor = '';
            openAtcModal();
          }, 1500);
        } else {
          throw new Error('Failed');
        }
      } catch (err) {
        atcBtn.disabled = false;
        atcBtn.textContent = atcBtn.dataset.error || 'Try again';
      }
    });
  }

  // ---- Update cart count ----
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.querySelector('.site-header__cart-count');
      if (cart.item_count > 0) {
        if (countEl) {
          countEl.textContent = cart.item_count;
        } else {
          const cartLink = document.querySelector('.site-header__cart');
          if (cartLink) {
            const span = document.createElement('span');
            span.className = 'site-header__cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        }
      }
    } catch (err) {
      console.error('Cart count update failed', err);
    }
  }

});